import { ReactNode, useContext } from 'react';

import WorkOrdersContext, {
  FilterSection,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, IconButton } from '@atom/mui';
import {
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
  PlaceIcon,
} from '@atom/mui/icons';
import { Client } from '@atom/utilities/featureToggleUtilities';
import { toggleFromSet } from '@atom/utilities/setUtilities';
import { taskLocationClient } from '@atom/utilities/tenantFeatureUtilities';

import WorkFilterLocationAldotFilters from './WorkFilterLocationAldotFilters';
import WorkFilterLocationUdotFilters from './WorkFilterLocationUdotFilters';

import classes from './workOrdersFilters.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const WorkOrdersFiltersLocationSection = () => {
  const { collapsedSections, setCollapsedSections } =
    useContext(WorkOrdersContext);

  const onToggle = (section: FilterSection) => {
    setCollapsedSections(toggleFromSet(collapsedSections, section));
  };

  const getTenantInputs = (): ReactNode => {
    switch (taskLocationClient) {
      case Client.UDOT:
        return <WorkFilterLocationUdotFilters />;
      case Client.ALDOT:
        return <WorkFilterLocationAldotFilters />;
      default:
        return <></>;
    }
  };

  return (
    <div className={classes.filtersSection}>
      <div className={classes.filtersSectionHeader}>
        <div>
          <Icon style={styles.icon} icon={PlaceIcon} />
          Locations
        </div>
        <IconButton
          onClick={() => onToggle(FilterSection.LOCATIONS)}
          edge="end"
        >
          <Icon
            icon={
              collapsedSections.has(FilterSection.LOCATIONS)
                ? KeyboardArrowDownIcon
                : KeyboardArrowUpIcon
            }
          />
        </IconButton>
      </div>
      {!collapsedSections.has(FilterSection.LOCATIONS) && (
        <div className={classes.filtersSectionContent}>{getTenantInputs()}</div>
      )}
    </div>
  );
};

export default WorkOrdersFiltersLocationSection;
